import { useEffect, useRef, useState } from "react";

import ReactQuill from 'react-quill';

import { Box } from "@mui/system";

import 'react-quill/dist/quill.snow.css';
import './index.scss';

const RichTextEditor = (props) => {
    const { value, onChange } = props;

    return (
        <Box
            sx={{
                width: '100%',
            }}
        >
            <ReactQuill
                theme={'snow'}
                value={value}
                onChange={onChange}
                style={{
                    height: '15rem',
                    marginBottom: '2.5rem'
                }}
            />
        </Box>
    )
}

export default RichTextEditor;